module.exports = __webpack_public_path__ + "img/devices.5fb293f8.png";